// TODO: no need for hook; a simple JS file with these pure utility functions is sufficient
import { userToString } from "./useUsers"

/**
  type Team = {
    members: {
      person_id: number
    }[]
  }
 */
const useTeam = () => {
  const teamUsersToStr = (team) => {
    if (Array.isArray(team)) {
      let map = new Set()
      team.forEach((role) => {
        role.members.forEach((member) => {
          map.add({ id: member.person_id, text: member.person_fullname + " (" + role.role_name + ")" })
        })
      })
      return Array.from(map)
    }
    return []
  }

  /**
    type Team = {
      members: {
        person_id: number
      }[]
    }
   */
  const teamUsersToIds = (team) => {
    if (Array.isArray(team)) {
      let map = new Set()
      team.forEach((role) => {
        role.members.forEach((member) => {
          map.add(member.person_id)
        })
      })
      return Array.from(map)
    }
    return []
  }

  return {
    teamUsersToStr,
    teamUsersToIds,
  }
}

export default useTeam
